<ng-container *showForRole="['ADMIN', 'SUPERADMIN']">

		@if(quoterState().agent && quoterState().agent.id){
			<app-selected-agent [user]="quoterState().agent" (clearUser)="clearUser()"/>
		}
	</ng-container>
<div class="app__container mt-10 flex flex-col items-center">
	<h2>Nuevo seguro</h2>
	<p>Elegí el riesgo que querés cotizar</p>

	<app-risk-list
		[loading]="loading()"
		[risks]="risks()"
		(selectEvent)="setRisk($event)" />

	@if (error()) {
		<p class="text-danger-500 mt-3 text-center">{{ error() }}</p>
	}
</div>
<ng-container *showForRole="['ADMIN', 'SUPERADMIN']">
	<app-producer-selector-modal (userSelected)="setAgent($event)"/>
</ng-container>
